<template>
<div>
    <div class="post-view" v-if="currentPost">
      <vue-gallery-slideshow
        :images="allGalleryImages" :index="index"
        @close="index = null"
      ></vue-gallery-slideshow>  
      <div class="container quilWrapper">
          <h2>{{ this.currentPost[0].blogTitle }}</h2>
          <img class="wappen" :src="require(`../assets/blogPhotos/${this.currentPost[0].blogCoverPhoto}.jpg`)" alt="" />
          <div class="post-content" v-for="(chapter, index) in this.currentPost[0].blogHTML" :key="index">
              <div class="chapter-content">
                  <h4 v-if="chapter.chapterTitle">{{ chapter.chapterTitle }}</h4>
                  <p v-html="chapter.chapterHTML"></p>
                  <div class="chapter-photo-wrap">
                    <div class="chapter-photos">
                        <b-img class="chapter-photo" thumbnail fluid v-bind="photoProps" v-for="photo in chapter.chapterPhotos" :key="photo"
                          :src="require(`../assets/blogPhotos/chapterPhotos/${photo}.jpg`)"
                          @click="openGalleryAtChapterPhoto(photo)"
                        ></b-img>
                    </div>
                  </div>
              </div>            
          </div>
      </div>
      <div class="additional-photo-wrap" v-if="this.additionalPhotos">
        <div class="additional-photos">
          <img class="single-photo" v-for="(photo, i) in this.additionalPhotos" :key="photo"
            :src="require(`../assets/blogPhotos/blogAdditionalPhotos/${photo}.jpg`)"
            @click="openGalleryAtAdditionalPhoto(i)"
          />
        </div>
      </div>
    </div>
</div>
</template>

<script>
import VueGallerySlideshow from 'vue-gallery-slideshow';

export default {
    name: "ViewPost",
    components: {
      VueGallerySlideshow,
    },
    data() {
        return {
            currentPost: null,
            additionalPhotos: null,
            index: null,
            photoProps: { class: 'm2' },
            thumbnailImages: [],      
        };
    },
    computed: {
      allGalleryImages() {
        if (!this.currentPost || this.currentPost.length === 0) {
          return [];
        }

        let images = [];

        // Add slideshow images (chapter photos)
        if (this.currentPost[0].slideshowImages) {
          images = [...this.currentPost[0].slideshowImages];
        }

        // Add additional photos
        if (this.additionalPhotos && this.additionalPhotos.length > 0) {
          const additionalImages = this.additionalPhotos.map(photo =>
            require(`../assets/blogPhotos/blogAdditionalPhotos/${photo}.jpg`)
          );
          images = [...images, ...additionalImages];
        }

        return images;
      },
      chapterPhotosCount() {
        return this.currentPost && this.currentPost[0] && this.currentPost[0].slideshowImages
          ? this.currentPost[0].slideshowImages.length
          : 0;
      }
    },
    watch: {
      '$route'(to, from) {
        // React to route changes when navigating between different blog posts
        if (to.params.blogid !== from.params.blogid) {
          this.loadBlogPost();
        }
      }
    },
    methods: {
      openGalleryAtChapterPhoto(photoName) {
        // Find the index of this photo in the allGalleryImages array
        const chapterImagePath = require(`../assets/blogPhotos/chapterPhotos/${photoName}.jpg`);
        const galleryIndex = this.allGalleryImages.findIndex(img => img === chapterImagePath);
        this.index = galleryIndex >= 0 ? galleryIndex : 0;
      },
      openGalleryAtAdditionalPhoto(additionalPhotoIndex) {
        // Additional photos start after all chapter photos
        this.index = this.chapterPhotosCount + additionalPhotoIndex;
      },
      loadBlogPost() {
        // Reset data before loading new post
        this.thumbnailImages = [];
        this.index = null;

        // Find and load the blog post based on route parameter
        this.currentPost = this.$store.state.blogPostArray.filter((post) => {
          return post.blogID === parseInt(this.$route.params.blogid);
        });

        if (this.currentPost.length > 0) {
          this.additionalPhotos = this.currentPost[0].blogAdditionalPhotos;

          // Build thumbnail images array from chapter photos
          for (let i = 0; i < this.currentPost[0].blogHTML.length; i++) {
            if (this.currentPost[0].blogHTML[i].chapterPhotos) {
              this.thumbnailImages.push(this.currentPost[0].blogHTML[i].chapterPhotos);
            }
          }
        }
      }
    },
    mounted() {
      this.loadBlogPost();
    }
};
</script>

<style lang="scss">

.post-view {
  min-height: 100%;
  
  .container {
    max-width: 1400px;
    padding: 60px 10px;
  }

  h2 {
    font-weight: bold;
    margin-bottom: 32px;
    font-weight: 600;
    padding: 32px;


    @media(min-width: 500px) {
      font-size: 24px;
    }

    @media(min-width: 900px) {
      font-size: 32px;
    }

    @media(min-width: 1200px) {
      font-size: 48px;
    }
  }

  .wappen {
    display: block;
    max-height: 500px;
    max-width: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center 30%;
    margin: 0 auto;
    margin-bottom: 48px;
  }

  .post-content {
    margin: 0 auto;
    max-width: 1000px;
  }

  h4 {
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 24px;
    margin-left: 24px;
  }

  p {
    padding: 24px;
    font-size: 18px;
    text-align: justify;
    white-space: pre-line;
  }

  .single-photo {
    position: relative;
    cursor: pointer;
    margin-bottom: 0px;
    width: 100%;
    max-width: 300px;
    height: 300px;
    object-fit: cover;
    object-position: center 30%;

    @media (max-width: 350px) {
      height: 250px;
    }
  }

  
  .chapter-content {
    width: 100%;
    margin: 0 auto;
  }

  .chapter-photo-wrap {
    width: 100%;
    padding: 30px 16px;
    background-color: #fff;
    @media(min-width: 500px) {
    padding: 0px 16px 30px 16px;
    }

    .chapter-photos {
      margin: 0 auto;
      text-align: center;
    }

    .chapter-photo {
      width: 100%;
      max-width: 300px;
      height: 300px;
      object-fit: cover;
      object-position: center 30%;
      margin: 6px;

      @media (max-width: 350px) {
        height: 250px;
        margin: 3px;
      }
    }
  }

}
</style>